import { Extension } from '@tiptap/core'
import { storeToRefs } from 'pinia'

import { ActionButton } from '@/components/editor'
import { useEditorStore } from '@/stores'
import type { GeneralOptions } from '@/types'
export type PrinterOptions = GeneralOptions<PrinterOptions>

export const Printer = Extension.create<PrinterOptions>({
  name: 'printer',
  addOptions() {
    return {
      ...this.parent?.(),
      button: () => {
        const editorStore = useEditorStore()
        const { printer } = storeToRefs(editorStore)
        const { togglePrinter } = editorStore

        return {
          component: ActionButton,
          componentProps: {
            tooltip: 'Print',
            action: () => {
              togglePrinter()
            },
            icon: 'Printer',
            ignoreDisabled: true,
            shortcutKeys: ['mod', 'P'],
            isActive: () => printer.value,
          },
        }
      },
    }
  },
})
